class TrainingPurchaseFields extends HTMLElement {
  /** @type {HTMLFormElement | null} */
  #form = null;

  /** @type {MutationObserver | null} */
  #observer = null;

  connectedCallback() {
    this.#form = this.closest('form');
    if (!this.#form) return;

    this.addEventListener('input', this.#updateAcceleratedCheckout);
    this.addEventListener('change', this.#updateAcceleratedCheckout);
    this.#form.addEventListener('submit', this.#validate, true);
    this.#observer = new MutationObserver(this.#updateAcceleratedCheckout);
    this.#observer.observe(this.#form, { childList: true, subtree: true });

    requestAnimationFrame(this.#updateAcceleratedCheckout);
  }

  disconnectedCallback() {
    this.removeEventListener('input', this.#updateAcceleratedCheckout);
    this.removeEventListener('change', this.#updateAcceleratedCheckout);
    this.#form?.removeEventListener('submit', this.#validate, true);
    this.#observer?.disconnect();
  }

  get fieldsAreValid() {
    return [...this.querySelectorAll('[required]')].every((field) => field.checkValidity());
  }

  #updateAcceleratedCheckout = () => {
    const acceleratedCheckout = this.#form?.querySelector('.accelerated-checkout-block');
    if (!(acceleratedCheckout instanceof HTMLElement)) return;

    const isValid = this.fieldsAreValid;
    acceleratedCheckout.toggleAttribute('inert', !isValid);
    acceleratedCheckout.setAttribute('aria-disabled', String(!isValid));
  };

  #validate = (event) => {
    if (this.fieldsAreValid) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    this.#form?.reportValidity();
  };
}

if (!customElements.get('training-purchase-fields')) {
  customElements.define('training-purchase-fields', TrainingPurchaseFields);
}
